import { Box } from "@mui/material";
import DashboardApp from "./DashboardApp";
import DashboardPerseusPay from "./DashboardPerseusPay";
import { setDealerId } from "../../features/dealer/dealerSlice";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import {
  DealerProfile,
  GetDealerPaymentGateway,
  GetDealerSettings
} from "../../utils/UtilTarget";
import { isEmpty } from "../../utils/Util";
import { Navigate, useNavigate } from "react-router-dom";

export default function DashboardMain() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const stateDealerId = useAppSelector(
    (state: RootState) => state.dealer.dealerId
  );
  const [paymentGatewayId, setPaymentGatewayId] = useState<number>(-1);
  const [dealerId, setDealerIdLocal] = useState<any>(GetDealerId());
  const [tlDomainUser, setTlDomainUser] = useState<string>("false");

  function GetDealerId() {
    return stateDealerId;
  }

  useEffect(() => {
    GetPaymentGateway();
  }, [dealerId]);

  async function GetPaymentGateway() {
    const isTLDomainUser = localStorage.getItem("isTLDomainUser");
    setTlDomainUser(isTLDomainUser);
    if (isTLDomainUser === "true") return;

    const group_dealerId = localStorage.getItem("group_dealerId");

    let _dealerId = dealerId;
    _dealerId = await DealerProfile("dealerId");

    if (!isEmpty(group_dealerId)) {
      _dealerId = group_dealerId;
      setDealerIdLocal(_dealerId);
      dispatch(setDealerId(_dealerId));
    } else {
      if (isEmpty(dealerId) || dealerId != _dealerId) {
        _dealerId = await DealerProfile("dealerId");
        if (isEmpty(_dealerId)) _dealerId = -1;

        setDealerIdLocal(_dealerId);
        dispatch(setDealerId(_dealerId));
        return;
      }
    }

    // Get Dealer Settings
    await GetDealerSettings(_dealerId);
    // Get Dealer Payment Gateway
    let payment_gateway = localStorage.getItem("payment_gateway");
    if (isEmpty(payment_gateway)) {
      payment_gateway = await GetDealerPaymentGateway(_dealerId);

      if (isEmpty(payment_gateway)) {
        navigate("/401");
        return;
      }
    }
    setPaymentGatewayId(Number(payment_gateway));
  }

  return (
    <Box>
      {paymentGatewayId === 0 && tlDomainUser === "false" && (
        <Navigate to="/dashboard/perseuspaysetting" />
      )}
      {paymentGatewayId === 1 && tlDomainUser === "false" && <DashboardApp />}
      {paymentGatewayId === 2 && tlDomainUser === "false" && (
        <DashboardPerseusPay DealerId={dealerId} />
      )}
      {tlDomainUser === "true" && <Navigate to="/dashboard/preonboarding" />}
    </Box>
  );
}
